// import { getUploadUrl , uploadResource } from '@/api/user';
import { LOCAL_STORE, SOURCES_URL } from "@/config/constConfig";
import store from "@/store"
import { AlertData } from "./Define";
import { getRandom32 } from "./math";

let sourceIndex = 0;

// URL地址解析
export function getJsUrl(url: any): any {
    var pos, str, para, parastr;
    var array: any = []
    str = location.href;
    parastr = str.split("?")[1];
    var arr = parastr.split("&");
    for (var i = 0; i < arr.length; i++) {
        array[arr[i].split("=")[0]] = arr[i].split("=")[1];
    }
    return array;
}

// 复制
export function copy(data: any) {
    // if (navigator.clipboard) {
        // navigator.clipboard.writeText(data);
    // } else {
        let OrderNumber = data;
        let newInput = document.createElement("input");
        newInput.value = OrderNumber;
        document.body.appendChild(newInput);
        newInput.select();
        document.execCommand("Copy");
        newInput.remove();
    // }
}

// 粘贴
export function getClipboardContent() {
    let result = "";
    if (navigator.clipboard) {
        navigator.clipboard.readText().then((res)=> {
           return res;
        }).catch((err) => {
            console.log("error:", err)
        });
    } else {
        let el = document.createElement('textarea');
        document.body.appendChild(el);
        el.focus();
        document.execCommand('paste');
        result = el.value;
        // document.body.removeChild(el);
    }
    // alert("clipboardData===>"+result);
    console.log("clipboardData", result);
    return result;
    
}

// 判断是否是app
export function getIsApp() {
    let isApp = process.env.VUE_APP_ISAPK;
    if (isApp == "true") {
        return true;
    }
    return false;
}

/**检测是否展示下载app按钮*/
export function checkIsShowDownload () {
    let facebookId = localStorage.getItem('appId');
    let myLevel = localStorage.getItem('myLevel');
    
    const params = new URLSearchParams(window.location.search);
    let code = params.get("code");
    if ((facebookId && facebookId != 'null')
        || code || (myLevel && Number(myLevel) >= 1)
        || store.state.accountInfo.gold >= 50000) {
        return true;
    } else {
        return false;
    }
}

/**获取链接域名端口号*/
export function getBaseUrl () {
    /**获取当前地址+拼接*/
    let baseUrl =location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "") + "/";
    return baseUrl
}

/**转换静态资源url */
export function covertSourceUrl(sourceUrl: string): string {
    let newSource = SOURCES_URL[sourceIndex];
    const reg = /((https|http|ftp|file):\/\/)([A-Za-z0-9\-.]+)(:[0-9]+){0,1}/g;
    let arr: any = sourceUrl.match(reg);
    sourceUrl = sourceUrl.replace((arr&&arr[0])?arr[0]:"https://gomakemoney.s3.sa-east-1.amazonaws.com", newSource);
    sourceIndex ++;
    if (sourceIndex == SOURCES_URL.length) {
        sourceIndex = 0;
    }
    return sourceUrl;
}

/**获取手机类型 */
export function getPhoneType(): string {
    let u = navigator.userAgent;
    let isAndroid = false;
    let isIOS = false;
    isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
    isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
    if (isAndroid == true) {
      return "Android";
    } else if (isIOS == true) {
        return "IOS";
    } else {
        return "PC";
    }
};

/**获取链接参数 */
export function getLinkParams(): any {
    return new URLSearchParams(window.location.search);
}

/**
 * 排序 
 * @param order 1:顺序 2:倒序
 * @param datas 数据
 * @param sortField 排序的字段
*/
export function sortDatas(datas: any, sortField: string = "id", order: number = 1) {
    datas.sort(function(a: any, b: any) {
        if (order == 1) {
            if (a[sortField] < b[sortField]) {
                return -1;
            }
            if (a[sortField] > b[sortField]) {
                return 1;
            }
        } else {
            if (a[sortField] > b[sortField]) {
                return -1;
            }
            if (a[sortField] < b[sortField]) {
                return 1;
            }
        }
        return 0;
    });
}

/**转换时间 */
export function dateFormat(fmt: string, date: Date) {
    let ret;
    const opt: any = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
        fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
        );
        }
    }
    return fmt;
}

/**显示提示界面 */
export function showAlert(isShow: boolean, alertData: AlertData) {
    store.state.alertData = alertData;
    store.state.isShowAlert = isShow;
}

/**获取cookie */
export function getCookie(name: string) {
    const value = document.cookie;
    // const value = "package_name=com.lunasoft.weatherzone; google_ad_id=a6dfd3a8-e835-4e82-a803-ed81759d995a; tracker_token=1ps2khx7; tracker_name=moloco::FateFlipWheel_AND_IND_AEO_firstrecharge_0627::com.ludo.win.cash::X0OQEx5pAQJCbi1b:a:rEo2z2CL2gefOSn2; network=moloco; campaign=FateFlipWheel_AND_IND_AEO_firstrecharge_0627; adgroup=com.ludo.win.cash; creative=X0OQEx5pAQJCbi1b:a:rEo2z2CL2gefOSn2; _ga=GA1.1.1630743497.1751281091; _ga_T63NSPF63L=GS2.1.s1751296152$o2$g0$t1751296153$j59$l0$h0";
    if (value) {
        var parts: any = value.split(`${name}=`);
        if (parts && parts.length === 2) {
            return parts.pop().split(';').shift();
        }
        return "";
    }
}

//获取设备id
export function getDeviceId() {
    let deviceId = localStorage.getItem(LOCAL_STORE.DEVICE_ID);
    if (deviceId) {
        return deviceId;
    } else {
        deviceId = getRandom32(20);
        let timerStr: string = "" + new Date().getTime();
        deviceId += timerStr.substring(timerStr.length - 12, timerStr.length);
        localStorage.setItem(LOCAL_STORE.DEVICE_ID, deviceId);
    }
    return deviceId;
}

export function isJSON(str: any) {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}
